import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import main from '../reducers/main';
import profiles from './profiles';
import amateurFilms from './amateurFilms';
import wallMaterials from './wallMaterials';
import wardrobeMaterials from './wardrobeMaterials';
import wishlists from './wishlists';
import member from './member';
import memberConversations from './memberConversations';

import pm from 'pm-js/build/reducers/pmConversations';
//import pm from 'local-pm-js/build/reducers/pmConversations';

import memberPhotos from './memberPhotos';
import memberAmateurFilms from './memberAmateurFilms';
import memberBobstoreProductsOwned from './memberBobstoreProductsOwned';
import memberWallMaterials from './memberWallMaterials';
import memberVirtualGifts from './memberVirtualGifts';
import memberGuestbook from './memberGuestbook';
import memberWallet from './memberWallet';
import memberWalletCharge from './memberWalletCharge';
import memberWalletReplenish from './memberWalletReplenish';
import memberPaymentHistory from './memberPaymentHistory';
import memberFollowing from './memberFollowing';
import memberFollowed from './memberFollowed';
import memberBlackList from './memberBlackList';
import memberMessageList from './memberMessageList';
import memberMessageDialog from './memberMessageDialog';
import memberNotificationList from './memberNotificationList';
import memberNotificationSetting from './memberNotificationSetting';
import profile from './profile';
import profileAlbum from './profileAlbum';
import profileAmateurFilms from './profileAmateurFilms';
import profileWallPosts from './profileWallPosts';
import profileWishlist from './profileWishlist';
import profileGuestbook from './profileGuestbook';
import buyXXL from './buyXXL';
import virtualGifts from './virtualGifts';
import currentUser from './currentUser';
import authToken from './authToken';
import amateurFilm from './amateurFilm'
import memberPhoto from './memberPhoto'
import photoList from './photoList'
import wallMaterial from './wallMaterial'
import cgu from './cgu';
import footer from './footer';
import visibility from './visibility';

const createRootReducer = history => combineReducers({
    main: main,
    profiles: profiles,
    amateurFilms: amateurFilms,
    wallMaterials: wallMaterials,
    wardrobeMaterials: wardrobeMaterials,
    wishlists: wishlists,
    member: member,
    memberConversations: memberConversations,
    memberBobstoreProductsOwned: memberBobstoreProductsOwned,
    memberPhotos: memberPhotos,
    memberAmateurFilms: memberAmateurFilms,
    memberWallMaterials: memberWallMaterials,
    memberVirtualGifts: memberVirtualGifts,
    memberGuestbook: memberGuestbook,
    memberWallet: memberWallet,
    memberWalletCharge: memberWalletCharge,
    memberWalletReplenish: memberWalletReplenish,
    memberPaymentHistory: memberPaymentHistory,
    memberFollowing: memberFollowing,
    memberFollowed: memberFollowed,
    memberBlackList: memberBlackList,
    memberMessageList: memberMessageList,
    memberMessageDialog: memberMessageDialog,
    memberNotificationList: memberNotificationList,
    memberNotificationSetting: memberNotificationSetting,
    pm: pm,
    profile: profile,
    profileAlbum: profileAlbum,
    profileAmateurFilms: profileAmateurFilms,
    profileWallPosts: profileWallPosts,
    profileWishlist: profileWishlist,
    profileGuestbook: profileGuestbook,
    buyXXL: buyXXL,
    virtualGifts: virtualGifts,
    currentUser: currentUser,
    authToken: authToken,
    amateurFilm: amateurFilm,
    memberPhoto: memberPhoto,
    photoList: photoList,
    wallMaterial: wallMaterial,
    cgu: cgu,
    footer: footer,
    visibility: visibility,
    ...(
        history
        && { router: connectRouter(history) }
      )
});

export default createRootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js